export enum ResourceFilterTypeEnum {
    Capacity = "Capacity",
    Available = "Available",
    ResourceName = "ResourceName",
    Category = "Category",
    Favourite = "Favourite",
    Location = "Location"
}